module.exports = __webpack_public_path__ + "static/media/test2_1.f921d4d6.png";